import React, { Component } from 'react'

export class About extends Component {
    render() {
        return (
            <div className='container'>
            <h1>About this App</h1>
            <br/>
            <h2>Welcome to Link Check</h2>
            <p>
            This is an application designed to scan your webpage and report the status of links and content.
            </p>
            <p>
            Select your desired search criteria by clicking on a tab and enter your desired URL in the format: protocol followed by hostname <code>(http://wwww.yourURL.com)</code>. <br/>Submit your request.
            </p>
            <p>
            Results are displayed as links in three colors: <br/><b class="blue">Blue</b> : In process <br/><b class="green">Green</b> : Connection established <br/><b class="red">Red</b> : Possible broken link or redirect
            </p>
            <p>
            For questions or concerns please contact 
            <a ng-href="#" onclick="window.open('mailto:AbrahamVera@gmail.com', '_system', 'location=yes'); return false;">
            Technical Support
            </a>
            . For more information and other services please visit our website:
            <a ng-href="#" onclick="window.open('http://www.ContentManagementSolutions.nyc', '_system', 'location=yes'); return false;">
                Content Management Solutions
            </a>
            </p>
            Copyright 2017 <br/> All Rights Reserved

        </div>
        )
    }
}

export default About



// WEBPACK FOOTER //
// ./src/components/pages/About.js